import { PageRoute } from './routes';

import { VrsRedirectTarget } from 'features/app/store/app/enums/vrsRedirectTarget';

const assertNever = (value: never): never => {
  throw new Error(`Unhandled VRS redirect target: ${String(value)}`);
};

export const getVrsRedirectRoute = (target: VrsRedirectTarget): PageRoute => {
  switch (target) {
    case VrsRedirectTarget.InCenterTeamingNotice:
      return PageRoute.VRS_IN_CENTER_TEAMING_NOTICE;
    case VrsRedirectTarget.TeamingLogoutNotice:
      return PageRoute.VRS_TEAMING_LOGOUT_NOTICE;
    default:
      return assertNever(target);
  }
};

export const shouldClearPendingVrsRedirectOnArrival = (
  target: VrsRedirectTarget
) => {
  switch (target) {
    case VrsRedirectTarget.InCenterTeamingNotice:
      return false;
    case VrsRedirectTarget.TeamingLogoutNotice:
      return true;
    default:
      return assertNever(target);
  }
};

export const getVrsRedirectRouteOrNull = (
  target: VrsRedirectTarget | null
): PageRoute | null => {
  if (target == null) {
    return null;
  }

  return getVrsRedirectRoute(target);
};
